import React, { Component } from 'react'
import '../card.css'
import { setAgacCali } from '../../../../store/actions/resultInfo'

class Card extends Component {

    async handleClick(){
        await setAgacCali(this.props.typeText)
        this.props.history.push("/yaprakTipi")
    }

    render() {
        return (
            <div onClick={() => this.handleClick()} class="card-outer-container result-card-outer-container">
                <div class="card-inner-container type-card-inner-container">
                    <div class="card-image-container">
                        <img class="type-card-image" src={this.props.image} alt={this.props.typeText + " image"} />
                    </div>
                    <div class="card-text-container">
                        <p class="card-text" style={{ whiteSpace: "pre-line"}}>{this.props.typeText}</p>
                    </div>
                </div>
            </div>
        )
    }
}

export default Card